var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 8,
  fill: "none",
  viewBox: "0 0 10 8",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.572.25a.728.728 0 0 0-1.1 0L3.527 5.692 1.327 3.274a.728.728 0 0 0-1.1 0 .92.92 0 0 0 0 1.209l2.749 3.023a.74.74 0 0 0 .55.25.74.74 0 0 0 .55-.25L9.571 1.46a.92.92 0 0 0 0-1.21"
})));
export { SvgCheckIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/check-icon.svg";